module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-woman-50_c513d94efbb5667973b6d048a5e11ab3.png";